// Inline Vite env declaration. The standard pattern is a top-level `src/vite-env.d.ts` referencing
// `vite/client` types — adding that file is Wave 1's responsibility. Until then, declare the
// fields this module reads. Replace with `/// <reference types="vite/client" />` (in a *.d.ts)
// in a follow-up wave.
// TODO(types): move to src/vite-env.d.ts (vite/client triple-slash) in a follow-up wave
declare global {
  interface ImportMetaEnv {
    readonly VITE_API_V3_URL?: string;
    readonly VITE_UPLOAD_API_URL?: string;
    readonly VITE_TRAINING_DATASET_URL?: string;
    readonly VITE_TRAINING_DATA_STORAGE_URL?: string;
    readonly VITE_RESUBMIT_INVOICE_URL?: string;
  }
  interface ImportMeta {
    readonly env: ImportMetaEnv;
  }
}

export const CORS_BYPASS = "https://cors-anywhere.herokuapp.com/";
// dev url
//export const BASE_API_URL = "https://dev-api-v3.ezcloud123.io";
//export const BASE_API_URL = "https://nfs8gfkn8a.execute-api.us-east-1.amazonaws.com/dev/";
// live url
//export const BASE_API_URL = "https://apiv3.ezcloud.co";
//trail url
// export const BASE_API_URL = "https://trial-apiv3.ezcloud.co/";
//test url
// Using environment variable with WCPSS DEV URL as fallback
// Vite uses import.meta.env.VITE_* for environment variables
export const BASE_API_URL =
  import.meta.env.VITE_API_V3_URL || "https://spn5fc8yzb.execute-api.us-east-1.amazonaws.com/wcpss";

export const LOGIN_URL = BASE_API_URL + "/user/login";
export const CREATE_CUSTOMER = BASE_API_URL + "/user/customerRegistration";
export const CREATE_PREMIUM_CUSTOMER = BASE_API_URL + "/user/createCustomer";
export const CREATE_TEAM_USER = BASE_API_URL + "/user/createTeamUser";
export const RESEND_WELCOME_EMAIL = BASE_API_URL + "/user/resendWelcomeEmail";
export const RESET_PASSWORD = BASE_API_URL + "/user/resetPassword";
export const GET_ADMIN_COUNT = BASE_API_URL + "/user/getAdminCount";
export const GET_INVOICE = BASE_API_URL + "/invoice/getInvoice";
export const GET_INVOICE_LIST = BASE_API_URL + "/invoice/getInvoiceList";
export const GET_MY_APPROVAL_HISTORY = BASE_API_URL + "/invoice/getMyApprovalHistory";
export const GET_INITIATORS_LIST = BASE_API_URL + "/invoice/getInitiatorsList";
export const GET_USERS = BASE_API_URL + "/user/getUsers";
export const GET_TEAMDETAILS_BY_ID = BASE_API_URL + "/team/getTeamDetailsById";
export const FORGET_PASSWORD = BASE_API_URL + "/user/forGetPassword";
export const UPDATE_PASSWORD = BASE_API_URL + "/user/updatePassword";
export const GET_USER_BY_ID = BASE_API_URL + "/user/getUserById";
export const UPDATE_USER = BASE_API_URL + "/user/updateUser";
export const UPDATE_TEAM = BASE_API_URL + "/team/updateTeam";
export const UPLOAD_FILE = BASE_API_URL + "/uploadFile/uploadFile";
export const GET_INVOICE_DETAILS = BASE_API_URL + "/invoice/getInvoiceById";
export const GUPDATE_INVOICE_DETAILS = BASE_API_URL + "/invoice/getInvoiceById";
export const DASHBOARD = BASE_API_URL + "/dashboard/getDashboard";
export const DASHBOARD_OVERVIEW = BASE_API_URL + "/dashboard/getDashboardOverview";
export const DASHBOARD_DAILYREPORT = BASE_API_URL + "/dashboard/getDailyCount";
export const DASHBOARD_SUPPLIERSTATICS = BASE_API_URL + "/dashboard/getSupplierStatistics";
export const DASHBOARD_WEEKLY_REPORT = BASE_API_URL + "/dashboard/GetWeeklyCount";
export const DASHBOARD_INVOICE_STATISTICS = BASE_API_URL + "/dashboard/GetInvoiceStatistics";
export const DASHBOARD_TEAM_STATISTICS = BASE_API_URL + "/dashboard/GetTeamMemberStatistics";
export const DASHBOARD_INVOICE_DISTRIBUTION = BASE_API_URL + "/dashboard/GetInvoiceDistribution";
export const DASHBOARD_APPROVAL_DISTRIBUTION =
  BASE_API_URL + "/dashboard/GetInvoiceApprovalDistribution";
export const UPDATE_INVOICE = BASE_API_URL + "/invoice/updateInvoice";
export const UPDATE_INVOICE_STATUS = BASE_API_URL + "/invoice/updateInvoiceStatus";
export const ACCESS_S3_FILE = BASE_API_URL + "/uploadFile/accessS3File";
export const ATTACH_SUPPORTING_DOC = BASE_API_URL + "/uploadFile/attachSupportingDoc";
export const REPLACE_INVOICE_DOCUMENT = BASE_API_URL + "/uploadFile/replaceInvoiceDocument";
export const TEAM_MEMBER_ASSIGN = BASE_API_URL + "/team/assignTeamMemberToSupplier";
export const GET_ASSIGNER_LIST = BASE_API_URL + "/team/getAssingerList";
export const GET_ASSIGNED_TEAM_LIST = BASE_API_URL + "/team/getAssingedTeamList";

export const SAVE_INVOICE_LINE_ITEMS = BASE_API_URL + "/invoice/saveInvoiceLineItems";

//Notification

export const SAVE_DEVICE = BASE_API_URL + "/notification/saveDevice";
export const DELETE_DEVICE = BASE_API_URL + "/notification/deleteDevice";
export const SAVE_NOTIFICATION_DETAILS = BASE_API_URL + "/notification/saveNotificationDetails";

//upload url for dev
//export const REUPLOAD_URL =
// "https://to77qk4lxa.execute-api.us-east-1.amazonaws.com/GetStartedLambdaProxyIntegration";
// upload url for live
// export const REUPLOAD_URL =
//   "https://kzewnk2xf5.execute-api.us-east-1.amazonaws.com/default/ezcloud-file-upload-handler";
//trail url
// export const REUPLOAD_URL =
// "https://6b7t38qpn0.execute-api.us-east-1.amazonaws.com/default/ezcloud-file-upload-handler";

//upload url for Test environment
// Now using environment variable with WCPSS DEV URL as fallback
// Note: VITE_UPLOAD_API_URL should be the base URL only (no path)
export const REUPLOAD_URL =
  import.meta.env.VITE_UPLOAD_API_URL ||
  "https://i615mag71b.execute-api.us-east-1.amazonaws.com/get-started";

//export const REUPLOAD_URL =
//"https://kzewnk2xf5.execute-api.us-east-1.amazonaws.com/default/ezcloud-file-upload-handler";

export const VERIFY_EMAIL_URL = BASE_API_URL + "/user/verifyCustomerEmail";
export const NEXT_INVOICE_URL = BASE_API_URL + "/invoice/getNextInvoice";
export const INVOICE_LINE_LISTING = BASE_API_URL + "/invoice/getInvoiceLine";
export const GET_TABLE_VALUES_BY_ID = BASE_API_URL + "/invoice/getTableValuesById";
export const INVOICELINE_CREATE_URL = BASE_API_URL + "/invoice/createInvoiceLine";
export const INVOICE_LINE_DELETE_URL = BASE_API_URL + "/invoice/deleteInvoiceLine";
export const INVOICE_LINE_UPDATE_URL = BASE_API_URL + "/invoice/updateInvoiceLine";
export const LOCK_INVOICE_URL = BASE_API_URL + "/invoice/lockInvoice";
export const UNLOCK_INVOICE_URL = BASE_API_URL + "/invoice/unLockInvoice";
export const GET_LOCKED_INVOICES_URL = BASE_API_URL + "/invoice/getLockedInvoices";
export const GET_INVOICE_FIELDS = BASE_API_URL + "/invoice/getInvoiceFieldList";
export const GET_KEYVALUES_BY_SUPPLIERNAME = BASE_API_URL + "/invoice/getKeyValuesBySupplierName";
export const UPDATE_INVOICE_FIELDS = BASE_API_URL + "/invoice/saveInvoiceFieldList";
export const GENERATE_OTP = BASE_API_URL + "/user/generateOTP";
export const VERIFY_OTP = BASE_API_URL + "/user/verifyOTP";

export const UPDATE_SUPPLIER_STATUS = BASE_API_URL + "/supplier/updateSupplierStatus";

export const SUPPLIER_LISTING = BASE_API_URL + "/supplier/getSupplierRequest";
export const SUPPLIER_SITE_LISTING = BASE_API_URL + "/supplier/getSupplierSiteDetails";
export const SUPPLIER_LISTING_RECLASIFICATION =
  BASE_API_URL + "/supplier/getSupplierReclarificationDetails";
export const BUDGET_MANAGER_LISTING = BASE_API_URL + "/budgetManager/getBudgetManagers";
export const ADD_BUDGET_MANAGER_URL = BASE_API_URL + "/budgetManager/addBudgetManager";
export const SCHOOL_DEPARTMENT_LISTING = BASE_API_URL + "/schoolDepartment/getSchoolDepartments";
// Single source of truth: Budget Codes feature
export const BUDGET_MANAGER_FROM_BUDGET_CODES = BASE_API_URL + "/budgetCode/distinctBudgetManagers";
export const SCHOOL_NAMES_FROM_BUDGET_CODES = BASE_API_URL + "/budgetCode/distinctSchoolNames";

export const ADD_SUPPLIER_REQUEST_URL = BASE_API_URL + "/supplier/sendSupplierRequest";
export const ADD_SUPPLIER_SITE_URL = BASE_API_URL + "/supplier/saveSupplierSiteDetails";

export const USER_SIGN_OUT_URL = BASE_API_URL + "/user/signOut";
export const USER_EMAIL_LIST_URL = BASE_API_URL + "/user/getEntityUser";
export const NOTIFY_SUPPLIER_URL = BASE_API_URL + "/supplier/sendPixelatedEmail";

export const NOTIFY_APPROVER_URL = BASE_API_URL + "/team/notifyApprovers";

export const UPDTAE_SUPPLIER_REQUEST_URL = BASE_API_URL + "/supplier/updateSupplierRequest";

export const UPDTAE_SUPPLIER_SITE_URL = BASE_API_URL + "/supplier/updateSupplierSiteDetails";

//enhancement
export const DELETE_INVOICE_URL = BASE_API_URL + "/invoice/deleteInvoice";
export const INITIATOR_DELETE_INVOICE_URL = BASE_API_URL + "/invoice/initiatorDelete";
export const VOID_INVOICE_URL = BASE_API_URL + "/invoice/voidInvoice";
export const PRE_SIGNED_URL = BASE_API_URL + "/uploadFile/preSignedS3Url";
export const DELETE_SUPPLIER_REQUEST = BASE_API_URL + "/supplier/deleteSupplierRequest";
export const DELETE_TEAM_MEMBER = BASE_API_URL + "/user/deleteUser";
export const UPDATE_EXCEPTION_STATUS = BASE_API_URL + "/team/updateInvoiceException";

export const SUPPLIER_RECLARIFICATION = BASE_API_URL + "/supplier/supplierReclarification";

//report
export const REPORT_URL = BASE_API_URL + "/report/getInvoiceReport";
export const INVOICE_REPORT_URL = BASE_API_URL + "/report/GetInvoiceReportTest";
export const TEAM_REPORT_URL = BASE_API_URL + "/report/GetTeamMemberReport";
export const SUPPLIER_REPORT_URL = BASE_API_URL + "/report/GetSupplierReport";
export const STANDARD_DEVIATION_URL = BASE_API_URL + "/report/invoiceAmountMetrics";
export const MONTH_WISE_DEVIATION_URL = BASE_API_URL + "/report/invoiceReceivedMetrics";
export const ROUNDED_INVOICES_URL = BASE_API_URL + "/report/invoiceRoundedAmountMetrics";
//Comment

export const CREATE_COMMENT_URL = BASE_API_URL + "/comment/createComment";
export const UPDATE_COMMENT_URL = BASE_API_URL + "/comment/updateComment";
export const COMMENT_LIST_URL = BASE_API_URL + "/comment/getComments";
export const DELETE_COMMENT_URL = BASE_API_URL + "/comment/deleteComment";
export const COMMENT_BY_ID_URL = BASE_API_URL + "/comment/getCommentById";
export const COMMENT_USER = BASE_API_URL + "/comment/getChatUser";
//audits
export const GET_AUDIT_URL = BASE_API_URL + "/invoice/getAudits";
export const SAVE_AUDIT = BASE_API_URL + "/invoice/saveAudit";
export const UPDATE_INV_PROCESS_TIME = BASE_API_URL + "/invoice/updateInvProcessingTime";

export const IS_NEW_USER_URL = BASE_API_URL + "/user/checkIsNewSupplier";

export const FORMAT_SETTING_URL = BASE_API_URL + "/invoice/saveSettings";
export const GET_FORMAT_SETTING_URL = BASE_API_URL + "/invoice/getSettings";

//Cron
export const SAVE_CRON_DETAILS = BASE_API_URL + "/crone/saveCronDetails";
export const UPDATE_CRON_DETAILS = BASE_API_URL + "/crone/updateCronDetails";
export const GET_CRONE_DETAILS = BASE_API_URL + "/crone/getCroneDetails";
export const GET_EXPORTED_LIST = BASE_API_URL + "/crone/getExportedList";

// export const GET_INSTANT_EXPORT = BASE_API_URL + "/crone/getInstantExport";
export const GET_INSTANT_EXPORT = BASE_API_URL + "/crone/getInstantExport?";
// "https://demo-cron.ezcloudai.co/cron/getInstantExport";

//new extraction
export const EXTRACTION_FORM_URL = BASE_API_URL + "/invoice/getFormValuesById";
export const TRAINING_DATASET_URL = BASE_API_URL + "/entityDataset/saveEntityTrainingDataset";
// approve call dev environment
//export const SAVE_TRAINING_DATASET_URL =
// "https://65yo73d1ye.execute-api.us-east-1.amazonaws.com/default/update-entity-dataset-handler";
// approve call test environment
// Now using environment variable with WCPSS DEV URL as fallback
export const SAVE_TRAINING_DATASET_URL =
  import.meta.env.VITE_TRAINING_DATASET_URL ||
  "https://i615mag71b.execute-api.us-east-1.amazonaws.com/update-entity-dataset";

//when update call dev environment
//export const TRAINING_DATA_STORAGE_URL =
//"https://u56g45ubji.execute-api.us-east-1.amazonaws.com/ManualStage/update-detected-entity-handler";

//when update call test environment
// Now using environment variable with WCPSS DEV URL as fallback
export const TRAINING_DATA_STORAGE_URL =
  import.meta.env.VITE_TRAINING_DATA_STORAGE_URL ||
  "https://i615mag71b.execute-api.us-east-1.amazonaws.com/update-detected-entity";

//resubmit
// Now using environment variable with WCPSS DEV URL as fallback
// Note: VITE_RESUBMIT_INVOICE_URL should include the full path
export const RESUBMIT_INITIALIZED_INVOICE_URL =
  import.meta.env.VITE_RESUBMIT_INVOICE_URL ||
  "https://i615mag71b.execute-api.us-east-1.amazonaws.com/enqueue-invoice";

export const GET_TRAINED_DATASET_URL = BASE_API_URL + "/invoice/getInvoiceLabels";
// Vendor field-learning template (target -> learned label) — field-learning-reliable-apply-design.md rev 3
export const GET_SUPPLIER_FIELD_MAP_URL = BASE_API_URL + "/invoice/getSupplierFieldMap";

export const GET_SUPPLIER_LIST_URL =
  // BASE_API_URL + "/uploadFile/getSupplierList";
  BASE_API_URL + "/supplier/getSupplierDetails";

export const GET_SUPPLIER_LIST = BASE_API_URL + "/supplier/getSupplierDetails";

export const GET_EXCEPTION_HANDLER_DETAILS = BASE_API_URL + "/user/getExceptionHandlerDetails";

export const SAVE_INVOICE_EXCEPTION = BASE_API_URL + "/team/saveInvoiceException";

export const GET_INVOICE_EXCEPTION_LIST = BASE_API_URL + "/team/getExceptionInvoice";

export const IMPORT_GLCODE = BASE_API_URL + "/GLcode/importGLcode";

export const GET_TAG_VALUE = BASE_API_URL + "/GLcode/getTagValue";

export const SAVE_GLCODE_TAGVALUE = BASE_API_URL + "/GLcode/glCodeTagValue";

export const GET_ASSIGNED_GLCODE_VALUE = BASE_API_URL + "/GLcode/getAssignedGLcodeValue";

export const GET_GLCODE = BASE_API_URL + "/GLcode/generateGlCode";
export const DELETE_GLCODE = BASE_API_URL + "/GLcode/deleteGLcode";
export const VALIDATE_TWO_FACTOR_AUTH = BASE_API_URL + "/user/verify2faAuthenticationCode";
export const FORGET_TWO_FACTOR_AUTH = BASE_API_URL + "/user/forgetTwoFaAuthenticationCode";
export const RESEND_EMAIL = BASE_API_URL + "/supplier/resendSupplierRequest";
export const UPDATE_TWOFAAUTHENTICATION = BASE_API_URL + "/user/updateTwoFaAuthenticationCode";

export const EXCEPTION_NEXT_INVOICE_URL = BASE_API_URL + "/team/getNextExceptionInvoice";
export const UPDATE_IS_ERP = BASE_API_URL + "/crone/updateIsErp";

export const GET_NOTIFICATION_URL = BASE_API_URL + "/notification/getNotificationDetails";

export const ADD_SUB_SUPPLIER = BASE_API_URL + "/user/createTeamUser";

//Non-Duplicate
export const NON_DUPLICATE_URL = BASE_API_URL + "/invoice/nonDuplicateInvoice";

//Revalidate Invoice (Sync Button)
export const REVALIDATE_INVOICE_URL = BASE_API_URL + "/invoice/revalidate";

//Workflow Routing Feature Flag
export const GET_WORKFLOW_ROUTING_FLAG = BASE_API_URL + "/team/getWorkflowRoutingFlag";
export const UPDATE_WORKFLOW_ROUTING_FLAG = BASE_API_URL + "/team/updateWorkflowRoutingFlag";

//Initiator and Budget Manager Workflow
export const GET_BUDGET_MANAGERS_URL = BASE_API_URL + "/workflow/getBudgetManagers";
export const SAVE_ATTESTATION_URL = BASE_API_URL + "/workflow/saveAttestation";
export const SELECT_BUDGET_MANAGER_URL = BASE_API_URL + "/workflow/selectBudgetManager";
export const SEND_BACK_INVOICE_URL = BASE_API_URL + "/workflow/sendBackInvoice";

//ERP Integration Layer (Multi-Funding Distribution Split Feature)
// Frontend → v3 API → Spring Boot (follows existing architecture pattern)
export const GET_PO_DISTRIBUTIONS_URL = BASE_API_URL + "/erp/po";

//ERP Integration Layer (Multi-Site Supplier Selection Feature)
// Fetches ALL supplier sites from Oracle EBS for dropdown selection
export const GET_SUPPLIER_SITES_FROM_ERP_URL = BASE_API_URL + "/erp/suppliers";

//Out of Office Delegation
export const GET_OOO_STATUS_URL = BASE_API_URL + "/user/getOutOfOfficeStatus";
export const SET_OOO_URL = BASE_API_URL + "/user/setOutOfOffice";
export const GET_ELIGIBLE_DELEGATES_URL = BASE_API_URL + "/user/getEligibleDelegates";
export const GET_OOO_LIST_URL = BASE_API_URL + "/user/getOutOfOfficeList";
export const ADMIN_SET_OOO_URL = BASE_API_URL + "/user/adminSetOutOfOffice";
export const ADMIN_CANCEL_OOO_URL = BASE_API_URL + "/user/adminCancelOutOfOffice";
export const GET_DELEGATION_LOG_URL = BASE_API_URL + "/user/getDelegationLog";

//Email Notification Settings
export const GET_NOTIFICATION_SETTINGS_URL = BASE_API_URL + "/user/getNotificationSettings";
export const UPDATE_NOTIFICATION_SETTINGS_URL = BASE_API_URL + "/user/updateNotificationSettings";
export const GET_QUEUE_EMAIL_PREFERENCES_URL = BASE_API_URL + "/user/getQueueEmailPreferences";
export const UPDATE_QUEUE_EMAIL_PREFERENCES_URL =
  BASE_API_URL + "/user/updateQueueEmailPreferences";
export const GET_TEAM_NOTIFICATION_SETTINGS_URL =
  BASE_API_URL + "/user/getTeamNotificationSettings";
export const UPDATE_TEAM_NOTIFICATION_SETTINGS_URL =
  BASE_API_URL + "/user/updateTeamNotificationSettings";

//Workflow Configuration
export const GET_WORKFLOW_STAGES_URL = BASE_API_URL + "/workflow/getWorkflowStages";
export const UPDATE_WORKFLOW_STAGE_URL = BASE_API_URL + "/workflow/updateWorkflowStage";

//Multi-Workflow Support (Phase 5)
export const GET_WORKFLOWS_URL = BASE_API_URL + "/workflow/getWorkflows";
export const GET_WORKFLOWS_WITH_STAGES_URL = BASE_API_URL + "/workflow/getWorkflowsWithStages";
export const GET_WORKFLOW_BY_ID_URL = BASE_API_URL + "/workflow/getWorkflowById";
export const GET_WORKFLOW_STAGES_BY_WORKFLOW_ID_URL =
  BASE_API_URL + "/workflow/getWorkflowStagesByWorkflowId";

//Budget Code Mapping Import (Auto-Assignment Feature)
export const BUDGET_CODE_IMPORT_URL = BASE_API_URL + "/budgetCode/import";
export const BUDGET_CODE_LIST_URL = BASE_API_URL + "/budgetCode/list";
export const BUDGET_CODE_UNLINKED_URL = BASE_API_URL + "/budgetCode/unlinked";
export const BUDGET_CODE_LINK_URL = BASE_API_URL + "/budgetCode/link";
export const BUDGET_CODE_BULK_LINK_URL = BASE_API_URL + "/budgetCode/bulkLink";
export const BUDGET_CODE_DELETE_URL = BASE_API_URL + "/budgetCode";
export const BUDGET_CODE_CLEAR_URL = BASE_API_URL + "/budgetCode/clear";

//Inbox Tab Order
export const GET_INBOX_TAB_ORDER_URL = BASE_API_URL + "/user/getInboxTabOrder";
export const UPDATE_INBOX_TAB_ORDER_URL = BASE_API_URL + "/user/updateInboxTabOrder";

// RBAC Permissions
export const GET_PERMISSION_CATALOG_URL = BASE_API_URL + "/permission/catalog";
export const GET_ROLES_URL = BASE_API_URL + "/permission/roles";
export const GET_ROLE_PERMISSIONS_URL = BASE_API_URL + "/permission/role";
export const GET_USER_PERMISSIONS_URL = BASE_API_URL + "/permission/user";
export const CHECK_USER_PERMISSION_URL = BASE_API_URL + "/permission/user";
export const GRANT_USER_PERMISSION_URL = BASE_API_URL + "/permission/user/grant";
export const REVOKE_USER_PERMISSION_URL = BASE_API_URL + "/permission/user/revoke";
export const UPDATE_USER_ROLE_URL = BASE_API_URL + "/permission/user/role";
export const UPDATE_USER_PERMISSIONS_URL = BASE_API_URL + "/permission/user/permissions";
export const GET_WORKFLOW_QUEUES_URL = BASE_API_URL + "/permission/queues";
export const GET_USER_QUEUE_ASSIGNMENTS_URL = BASE_API_URL + "/permission/user";
export const UPDATE_USER_QUEUE_ASSIGNMENTS_URL = BASE_API_URL + "/permission/user/queues";
export const GET_PERMISSION_SETS_URL = BASE_API_URL + "/permission/sets";
export const APPLY_PERMISSION_SET_URL = BASE_API_URL + "/permission/user/applySet";
export const GET_USER_FULL_PERMISSIONS_URL = BASE_API_URL + "/permission/user";

// EBS Supplier Sync
export const SUPPLIER_SYNC_TRIGGER_URL = BASE_API_URL + "/supplierSync/trigger";
export const SUPPLIER_SYNC_STATUS_URL = BASE_API_URL + "/supplierSync/status";
export const SUPPLIER_SYNC_HISTORY_URL = BASE_API_URL + "/supplierSync/history";
export const SUPPLIER_SYNC_SUPPLIERS_URL = BASE_API_URL + "/supplierSync/suppliers";
export const SUPPLIER_SYNC_SITES_URL = BASE_API_URL + "/supplierSync/sites";
export const SUPPLIER_SYNC_CONFIG_URL = BASE_API_URL + "/supplierSync/config";

// EBS Supplier Sync - Invoice Form Integration (Phase 6)
export const SEARCH_EBS_SUPPLIERS_URL = BASE_API_URL + "/supplierSync/suppliers/search";
export const GET_EBS_SUPPLIER_SITES_BY_NAME_URL =
  BASE_API_URL + "/supplierSync/suppliers/byName/sites";

// Feature Flags
export const GET_FEATURE_FLAGS_URL = BASE_API_URL + "/team/getFeatureFlags";

// Smart Receipt Detection (Sprint 1 - PO Validation Enhancement)
// Returns receipt status for a PO: SERVICE/GOODS/MIXED type and FULLY_RECEIVED/PARTIAL/NOT_RECEIVED status
export const GET_RECEIPT_STATUS_URL = BASE_API_URL + "/erp/po";

// Sprint 4b - Blanket PO Balance Tracking
// Returns blanket PO status including total limit, invoiced amount, and remaining balance
export const GET_BLANKET_STATUS_URL = BASE_API_URL + "/erp/po";

// Sprint 4b - Fiscal Year Validation
// Returns fiscal period info for invoice date validation
export const GET_FISCAL_PERIOD_URL = BASE_API_URL + "/erp/fiscal-period";

// Sprint 4b - PO Date Validation
// Returns PO creation date for invoice date validation
export const GET_PO_DATES_URL = BASE_API_URL + "/erp/po";

// Sprint 4b - Enhanced PO Validation (PO Invoice Eligibility)
// Returns comprehensive PO eligibility check: closed, cancelled, fully billed, 3-way match, etc.
export const GET_PO_ELIGIBILITY_URL = BASE_API_URL + "/erp/po";

// Use Tax Code Lookup (Use Tax feature — queries Oracle DFF value set per pay group)
export const GET_USE_TAX_CODES_URL = BASE_API_URL + "/erp/use-tax-codes";

// Fund 6 Balance Validation (WCPSS)
// Returns paired account balance for Fund 6 expense accounts (06.5400.xxx)
// Formula: Available = Budget + Revenue YTD - Expense YTD
export const GET_FUND6_BALANCE_URL = BASE_API_URL + "/erp/fund6-balance";

// In-Workflow Receiving (Stage 1 bookkeeper confirms goods received → creates Oracle EBS receipt)
export const CONFIRM_RECEIVING_URL = BASE_API_URL + "/workflow/confirmReceiving";

// SSO (Single Sign-On) - Identity Automation / RapidIdentity
export const SSO_CHECK_URL = BASE_API_URL + "/sso/check";
export const SSO_AUTHORIZE_URL = BASE_API_URL + "/sso/authorize";
export const SSO_CONFIG_URL = BASE_API_URL + "/sso/config";
export const SSO_TEST_URL = BASE_API_URL + "/sso/test";
